<template>
  <div>
    <b-table
      :items="onderdeel.acties"
      :fields="fields"
      :foot-clone="true"
      :tbody-tr-class="rowClass"
      striped
      class="mt-3"
      fixed
      show-empty
      selectable
      empty-text="Nog geen herhalingen"
      @row-selected="onRowSelected"
    >
      <template #cell(omschrijving)="data">
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text
              v-b-tooltip.hover
              :class="
                getConditieClass(
                  huidigeConditieOpBasisVanUitvoering(
                    data.item,
                    onderdeel.jaar || onderdeel.basejaar
                  ).conditie
                )
              "
              :title="
                huidigeConditieOpBasisVanUitvoering(
                  data.item,
                  onderdeel.jaar || onderdeel.basejaar
                ).laatste
              "
            >
              conditie
              {{
                huidigeConditieOpBasisVanUitvoering(
                  data.item,
                  onderdeel.jaar || onderdeel.basejaar
                ).conditie
              }}
            </b-input-group-text>
          </b-input-group-prepend>
          <b-input
            v-model="data.item.naam"
            type="text"
            placeholder="Naam"
          />
          <b-input-group-addon>
            <b-form-radio-group
              v-model="data.item.groep"
              :options="groepen"
              buttons
              class="mr-1"
              button-variant="outline-secondary"
            />
          </b-input-group-addon>
        </b-input-group>

        <b-textarea
          v-model="data.item.omschrijving"
          size="sm"
          placeholder="Inspectie notitie.."
          debounce="500"
        />

        <b-button-toolbar>
          <b-button
            class="btn btn-sm btn-danger pull-right mt-1"
            @click="onderdeel.acties.splice(data.index, 1)"
          >
            <i class="fa fa-trash" /> Herhaling verwijderen
          </b-button>
        </b-button-toolbar>
      </template>

      <template #cell(periode)="data">
        <b-input-group class="mb-2">
          <b-input-group-prepend>
            <b-input-group-text>van</b-input-group-text>
          </b-input-group-prepend>
          <b-input
            v-model.number="data.item.jaar"
            :placeholder="jaar.toString()"
            type="number"
          />
          <b-input
            v-model.number="data.item.einde"
            type="number"
            placeholder="tot"
          />
        </b-input-group>
        <b-input-group class="mb-2">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="fa fa-euro fa-md" />
            </b-input-group-text>
          </b-input-group-prepend>
          <b-input
            v-model.number="data.item.startbedrag"
            type="number"
            placeholder="start bedrag"
          />
          <b-input
            v-model.number="data.item.bedrag"
            :disabled="data.item.bedraglocked"
            type="number"
          />
          <b-input-group-append is-text>
            <i class="fa fa-lock fa-md" />
            <b-checkbox
              v-model="data.item.bedraglocked"
              v-b-tooltip.hover
              class="ml-2"
              title="Bedrag wordt niet overschreven bij import"
            />
          </b-input-group-append>
        </b-input-group>
        <b-button
          v-if="onderdeel.import"
          :disabled="data.index > acties.length - 1"
          class="btn btn-sm btn-info pull-right mt-1"
          @click="importHerhaling(data.index, data.item)"
        >
          <i class="fa fa-magic" />
          Importeer {{ acties[data.index] ? acties[data.index].naam : "" }}
        </b-button>
      </template>

      <template #cell(cyclus)="data">
        <b-input-group class="mb-2">
          <b-input-group-prepend>
            <b-input-group-text>
              <i class="fa fa-refresh fa-md" />
            </b-input-group-text>
          </b-input-group-prepend>
          <b-input
            v-model.number="data.item.cyclus"
            type="number"
            min="1"
            oninput="validity.valid||(value='');"
          />
          <b-input-group-text>jaar</b-input-group-text>

          <b-input-group-append is-text>
            <b-checkbox
              v-model="data.item.stuck"
              v-b-tooltip.hover
              class="ml-2"
              title="Magneten hebben geen invloed op de cyclus."
            >
              vastzetten
            </b-checkbox>
          </b-input-group-append>
        </b-input-group>

        <b-input-group class="mb-2">
          <b-input-group-prepend is-text>
            levensduur
          </b-input-group-prepend>
          <b-input
            v-model.number="data.item.levensduur"
            type="number"
          />

          <b-input-group-text>jaar</b-input-group-text>
        </b-input-group>

        <b-input-group>
          <b-input-group-prepend is-text>
            voorwaarde
          </b-input-group-prepend>
          <b-select
            v-model="data.item.operator"
            :options="[
              { value: 'A', text: 'Altijd' },
              { value: 'B', text: 'Bij geen actie in jaar' },
            ]"
          />
        </b-input-group>
      </template>

      <template #row-details="row">
        <b-row class="m-1">
          <b-col>
            <cyclus-details 
              :actie="row.item" 
              :jaar="jaar"
            />
          </b-col>
          <b-col>
            <b-textarea
              v-model="row.item.werkzaamheden"
              size="sm"
              placeholder="Benodigde werkzaamheden..."
            />
          </b-col>
        </b-row>
      </template>

      <template #foot(bedrag)>
        <span class="text-danger" />
      </template>

      <template #foot()>
&nbsp;
      </template>
    </b-table>

    <b-button-toolbar>
      <b-button-group>
        <b-button 
          class="btn-sm ghost" 
          @click="addActie('Revisie', 3, 1)"
        >
          <i class="fa fa-plus" /> Revisie
        </b-button>

        <b-button 
          class="btn-sm ghost" 
          @click="addActie('Vervanging ', 25, 0)"
        >
          <i class="fa fa-plus" /> Vervanging
        </b-button>
      </b-button-group>
    </b-button-toolbar>
  </div>
</template>
<script>
import CyclusDetails from "@/views/prognoses/onderdeel/CyclusDetails";
import Conditie from "../ConditieInvoer";
import { prognoseMixin } from "@/mixins/prognoseMixin";
export default {
  name: "Herhalingen",
  components: { CyclusDetails, Conditie },
  filters: {
    pretty: function (value) {
      return JSON.stringify(value, null, 2);
    },
  },
  mixins: [prognoseMixin],
  props: {
    onderdeel: { 
      type: Object,
      default: null 
    },
    jaar: { type: Number, default: new Date().getFullYear() },
    presets: { type: Array, default: () => [] },
    fotos: { type: Array,default: () => [] },
  },
  data() {
    return {
      geselecteerd: [],
      maxjaren: new Date().getFullYear() + 200,
      fields: ["Omschrijving", {key:"Periode", label: "Startjaar cyclus"}, "Cyclus"],
      prognose: null,
    };
  },
  computed: {
    acties: function () {
      var vm = this;
      var a = [];
      if (this.prognose) {
        (this.prognose.onderdelen || []).forEach((elem) =>
          elem.onderdelen.forEach(function (o) {
            if (o.legacyId == "onderdeel_" + vm.onderdeel.import)
              a = o.onderdelen;
          })
        );
      }
      return a;
    },
    importOnderdeel: function () {
      var vm = this;
      var result = {};
      if (this.prognose) {
        this.prognose.onderdelen.forEach((elem) =>
          elem.onderdelen.forEach(function (o) {
            if (o.legacyId == "onderdeel_" + vm.onderdeel.import) result = o;
          })
        );
      }
      return result;
    },
    importOptions: function () {
      if (this.prognose) {
        return {
          filter: this.onderdeel.import,
          prognosestartjaar: this.prognose.jaar,
          opmerking: this.importOnderdeel.huidigeConditie.opmerking,
          items: this.importOnderdeel.onderdelen
        };
      }
      return {}
    },
    ditjaar: function () {
      return new Date().getFullYear();
    },
    items: {
      get: function () {
        if (this.onderdeel.acties == null)
          this.$set(this.onderdeel, "acties", []);
        return this.onderdeel.acties.concat(this.onderdeel.gebreken);
      },
    },
  },
  watch: {
    jaar(newValue, oldValue) {
      console.log(newValue);
      console.log(oldValue);
      console.log(newValue - oldValue);
    },
  },
  mounted() {
    this.getImportPrognose();
  },
  methods: {
    rowClass(item, type) {
      console.log(type);
      if (type === 'row') {
        return 'bg-dark'
      } else {
        return null
      }
    },
    importHerhaling(index, item) {
      console.log(index, item);
      var importItem = this.acties[index];
      item.werkzaamheden = importItem.omschrijving;
      if (!item.bedraglocked) {
        item.bedrag =
          importItem.resultaat[
            importItem.eersteJaar - this.importOptions.prognosestartjaar
          ];
      }
      item.omschrijving = this.importOnderdeel.huidigeConditie.opmerking;
      item.jaar = importItem.eersteJaar - item.cyclus;
    },
    getImportPrognose() {
      var vm = this;
      this.$http
        .get("/unit/" + this.$route.params.id + "/prognose")
        .then(function (response) {
          vm.prognose = response.data.imports;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onRowSelected(items) {
      this.geselecteerd = items;
    },
    addActie(omschrijving, cyclus, groepindex) {
      this.onderdeel.acties.push({
        //omschrijving: '',
        jaar: null,
        groep: groepindex || 0,
        naam: omschrijving,
        bedrag: 100,
        cyclus: cyclus,
        levensduur: cyclus + 2,
        _showDetails: true,
        jaren: [],
      });
    },
  },
  
};
</script>